
import React from 'react';
import { createRoot } from 'react-dom/client';
import ClientTriage from './components/ClientTriage';

class ReactApp {
  constructor(rootId = 'react-client-triage') {
    this.rootElement = document.getElementById(rootId);
    if (this.rootElement) {
      this.init();
    }
  }

  init() {
    const root = createRoot(this.rootElement);
    root.render(<ClientTriage />);
  }
}

// Initialize the app
new ReactApp();